import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AccountingExportSettingState } from "../objects/accountingExportSettingState";
import { AccountingExportSetting } from "../objects/accountingExportSetting";

const initialState: AccountingExportSettingState = {
    export_setting_list: [],
    export_setting_list_loading: false,
    export_setting: null,
    export_setting_delete: null,
    variable_list: {},
    third_party_variable_list: {}
};

const setExportSettingListReducer = (state: AccountingExportSettingState, action: PayloadAction<AccountingExportSetting[]>): AccountingExportSettingState => ({
    ...state, export_setting_list: action.payload
});

const setExportSettingListLoadingReducer = (state: AccountingExportSettingState, action: PayloadAction<boolean>): AccountingExportSettingState => ({
    ...state, export_setting_list_loading: action.payload
});
const setExportSettingReducer = (state: AccountingExportSettingState, action: PayloadAction<AccountingExportSetting | null>): AccountingExportSettingState => ({
    ...state, export_setting: action.payload
});
const setExportSettingDeleteReducer = (state: AccountingExportSettingState, action: PayloadAction<AccountingExportSetting | null>): AccountingExportSettingState => ({
    ...state, export_setting_delete: action.payload
});
const setVariableListReducer = (state: AccountingExportSettingState, action: PayloadAction<Record<string, Record<string, string>>>): AccountingExportSettingState => ({
    ...state, variable_list: action.payload
});
const setThirdPartyVariableListReducer = (state: AccountingExportSettingState, action: PayloadAction<Record<string, Record<string, string>>>): AccountingExportSettingState => ({
    ...state, third_party_variable_list: action.payload
});
export const accountExportSetting = createSlice({
    name: 'accounting_export_setting',
    initialState,
    reducers: {
        setExportSettingList: setExportSettingListReducer,
        setExportSettingListLoading: setExportSettingListLoadingReducer,
        setExportSetting: setExportSettingReducer,
        setExportSettingDelete: setExportSettingDeleteReducer,
        setVariableList: setVariableListReducer,
        setThirdPartyVariableList: setThirdPartyVariableListReducer
    }
});

export const {
    setExportSettingList,
    setExportSettingListLoading,
    setExportSetting,
    setExportSettingDelete,
    setVariableList,
    setThirdPartyVariableList
} = accountExportSetting.actions;